import React, { FC, useState } from 'react';

import { SerializedStyles } from '@emotion/react';
import * as Sentry from '@sentry/react';

import { css } from '../../styled';
import { colorsPalette } from '../../theme';
import IKImage, { InterfaceIKImage } from '../IKImage/IKImage';
import { Loader } from '../Loader';
import Ratio from '../Ratio';

interface ImageWithLoaderProps extends InterfaceIKImage {
  ratio: number;
  wrapperClass?: string;
  imgWrapperCss?: SerializedStyles;
}

const ImageWithLoader: FC<ImageWithLoaderProps> = ({
  ratio,
  wrapperClass = '',
  imgWrapperCss,
  path,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = (e) => {
    setIsLoading(false);
    Sentry.captureException(e);
  };

  return (
    <Ratio ratio={ratio} className={wrapperClass} contentWrapperCss={imgWrapper(imgWrapperCss)}>
      {isLoading && <Loader global={false} data-testid={`${rest['data-testid']}Loader`} />}
      <IKImage path={path} onLoad={handleLoad} onError={handleError} {...rest} />
    </Ratio>
  );
};

export default ImageWithLoader;

const imgWrapper = (...optionalStyles) => css`
  background: ${colorsPalette.violetAnalyticsCard};

  ${optionalStyles}
`;
